import { render, staticRenderFns } from "./PlacePartAdd.vue?vue&type=template&id=be9b4bce&"
import script from "./PlacePartAdd.vue?vue&type=script&lang=js&"
export * from "./PlacePartAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports